import debounce from 'lodash/debounce';
import getAudioInputDevicesChangeHandlerDefault from './audioInputDevicesChangeHandler';
import getNativeMediaDevicesFactoryDefault from '../helpers/deviceHelpers';
import EventsFactory from './events';

export default (deps = {}) => {
  const getAudioInputDevicesChangeHandler =
    deps.getAudioInputDevicesChangeHandler || getAudioInputDevicesChangeHandlerDefault;
  const getNativeMediaDevicesFactory =
    deps.getNativeMediaDevicesFactory || getNativeMediaDevicesFactoryDefault;

  const audioInputDevicesChangeHandler = getAudioInputDevicesChangeHandler();
  const {
    getNativeMediaDevices,
  } = getNativeMediaDevicesFactory();

  const debounceTime = deps.debounceTime ?? 200;
  const Events = EventsFactory();

  const audioInputDevicesChangeListener = (publisher) => {
    let isProcessing = false;
    // We need to debounce because some browsers (like Chrome) may fire multiple devicechange events
    const deviceChangeListener = debounce(async () => {
      if (isProcessing) {
        return;
      }
      isProcessing = true;
      const device = await audioInputDevicesChangeHandler(publisher._getAudioSource());
      isProcessing = false;
      if (device) {
        await publisher.setAudioSource(device.deviceId);
        publisher.dispatchEvent(Events.AudioInputDeviceChangedEvent(device));
      }
    }, debounceTime);
    // In order to keep the current device ID synchronized, let's listen to the device change event
    const mediaDevices = getNativeMediaDevices();
    mediaDevices.addEventListener('devicechange', deviceChangeListener);

    const removeAudioInputDevicesChangeListener = () => {
      mediaDevices.removeEventListener('devicechange', deviceChangeListener);
    };

    return removeAudioInputDevicesChangeListener;
  };

  return audioInputDevicesChangeListener;
};
